import { first, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class UnAuthGuard implements CanActivate {
    constructor(private userService: UserService, private router:Router, private snackBar: MatSnackBar) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.userService.isLoggedIn()
                .pipe(
                    map(response => {
                        const isLoggedIn = !!response.user;
                        if(isLoggedIn){
                            this.snackBar.open('You are already logged in!', 'OK').afterDismissed().pipe(first()).subscribe();
                            this.router.navigate(['/'], {queryParams: { originator: state.url }});
                        }
                        return !isLoggedIn;
                    })
                );
    }
}
